export const printBlob = async (blob: Blob) => {
  const blobUrl = URL.createObjectURL(blob);
  const printWindow = window.open(blobUrl, "_blank");
  if (!printWindow) {
    URL.revokeObjectURL(blobUrl);
    return;
  }

  printWindow.addEventListener("load", () => {
    // Clean up after user closes the print dialog or window
    const cleanup = () => {
      URL.revokeObjectURL(blobUrl);
    };

    // Listen for when the print dialog is closed (user printed or canceled)
    printWindow.addEventListener("afterprint", cleanup);

    // Also clean up if the window is closed
    printWindow.addEventListener("beforeunload", cleanup);

    setTimeout(() => printWindow.print(), 100);
  });
};
